'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SocialNaver = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("rect", {
                width: "16",
                height: "16",
                rx: "8",
                fill: "#02C659"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.2467 8.2464L6.6518 4.5H4.5V11.5H6.754V7.7529L9.3496 11.5H11.5V4.5H9.2467V8.2464Z",
                fill: "white"
            })
        ]
    });
};

module.exports = SocialNaver;
